import type { SearchTrail } from "../contract"
import { Fold } from "./Fold"
import { EventRow, type TimedStep } from "./Loader"

/** The loader, folded: "How NIRA searched · N steps · X.Xs". */
export function SearchFold({ trail, steps, title = "How NIRA searched" }: { trail?: SearchTrail; steps: TimedStep[]; title?: string }) {
  const rows: TimedStep[] = trail?.steps?.length
    ? trail.steps.map((s, i) => ({ id: `trail-${i}`, label: s.label, detail: "", status: "done", kind: "read", t: s.t }))
    : steps.map((s) => ({ ...s, status: s.status === "error" ? "error" : "done" }))
  if (!rows.length) return null
  const total = trail?.total_sec ?? Math.max(...rows.map((r) => r.t))
  return (
    <div className="how">
      <Fold label={`${title} · ${rows.length} ${rows.length === 1 ? "step" : "steps"} · ${total.toFixed(1)}s`}>
        <ol className="ev" style={{ margin: 0 }}>
          {rows.map((s) => <EventRow key={s.id} step={s} />)}
        </ol>
      </Fold>
    </div>
  )
}
